module.exports = __webpack_public_path__ + "static/media/chinese_04.c50f1b50.jpg";